@if (data?.title) {
  <sd-title
    [titleThemesConfig]="isBrand ? brandThemesEnum.brand : textThemesConfig"
    customClass="brand--h4"
    [titleLevel]="titleLevel"
  >
    {{data?.title}}
  </sd-title>
}

@if (data?.media) {
  <sd-banner
    class="is-main"
    [isFit]="true"
    [media]="data?.media"
    [hasAltText]="false"
  />
}

@if (data?.subtitle) {
  <p class="is-caption">
    {{ data?.subtitle }}
  </p>
}

@if (data?.icons?.length) {
  <ul class="c__icon-container d-flex">
    @for (item of data.icons; track $index) {
      <li class="{{$count > 1 ? 'is-relative' : ''}}">
        @if (item.link) {
          @if (!item.icon?.['url'] && !item.icon?.['urlTwicPic']) {
            @if (item.icon) {
              <sd-icon [name]="item.icon" [size]="item.size" />
            }
            <sd-link
              customClass="is-full-area"
              [ariaLabel]="item.buttonIconTitle"
              (clicked)="onClick(item.link)"
              [link]="item.link"
            >
              <span>{{item.link?.linkName}}</span>
            </sd-link>
          } @else {
            @if (item.icon) {
              <sd-banner
                class="is-main is-icon"
                [isFit]="true"
                [media]="item.icon"
                [hasAltText]="false"
              />
            }
            <sd-link
              customClass="is-full-area"
              [ariaLabel]="item.buttonIconTitle"
              (clicked)="onClick(item.link)"
              [link]="item.link"
            >
              <span>{{item.link?.linkName}}</span>
            </sd-link>
          }
        }
      </li>
    }
  </ul>
}
